/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTaskForm } from '../models/CreateTaskForm';
import type { EditTaskForm } from '../models/EditTaskForm';
import type { Task } from '../models/Task';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TasksService {
    /**
     * Find a task by id
     * @returns Task Task
     * @throws ApiError
     */
    public static findTask({
        id,
    }: {
        /**
         * Id of task.
         */
        id: number,
    }): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/projects/task/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the task.`,
            },
        });
    }
    /**
     * Edit a task
     * @returns Task Edited task
     * @throws ApiError
     */
    public static editTask({
        id,
        requestBody,
    }: {
        /**
         * Id of task.
         */
        id: number,
        /**
         *   The fields to be edited.
         * If a field is omitted, it will not be edited. If a field is set to null,
         * however, it will be - if possible - set to null.
         *
         * Endpoint can be typically used to set a task to completed (by only
         * providing this field).
         *
         */
        requestBody: EditTaskForm,
    }): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/projects/task/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the task.`,
            },
        });
    }
    /**
     * Delete a task
     * @returns any Task has been deleted.
     * @throws ApiError
     */
    public static deleteTask({
        id,
    }: {
        /**
         * Id of task.
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/projects/task/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the task.`,
            },
        });
    }
    /**
     * Create a new task
     * @returns Task Created task
     * @throws ApiError
     */
    public static createTask({
        requestBody,
    }: {
        /**
         *   The new task to be created. Only the `name` and `assignees` fields
         * are required. The `assignees` set can be empty however.
         *
         */
        requestBody: CreateTaskForm,
    }): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/projects/task',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request body is invalid: Both required fields could be missing or the name could be blank.`,
                403: `The user's team has no access to this feature or the user has no access to the specified project.`,
            },
        });
    }
    /**
     * Lists (filtered) tasks
     * @returns Task (Filtered) tasks
     * @throws ApiError
     */
    public static listTasks({
        completed,
        assigned,
        dueDate,
    }: {
        /**
         * Filter whether the tasks are completed or not.
         */
        completed?: boolean,
        /**
         * Filter if the executing user is assigned to the tasks.
         */
        assigned?: boolean,
        /**
         * Due date of the tasks.
         */
        dueDate?: string,
    }): CancelablePromise<Array<Task>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/projects/tasks',
            query: {
                'completed': completed,
                'assigned': assigned,
                'dueDate': dueDate,
            },
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the specified project.`,
            },
        });
    }
}
